import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function ClimStickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = document.querySelector("#devis");
    if (!target) return;
    let inForm = false;
    const io = new IntersectionObserver(
      ([entry]) => {
        inForm = entry.isIntersecting;
        setVisible(window.scrollY > 320 && !inForm);
      },
      { threshold: 0.25 }
    );
    io.observe(target);
    const onScroll = () => setVisible(window.scrollY > 320 && !inForm);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="clim-sticky-bar"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-x-0 bottom-0 z-40 flex gap-2 border-t border-glacier-border bg-white/95 p-3 shadow-[0_-10px_30px_rgba(15,23,42,0.08)] backdrop-blur-xl md:hidden"
        >
          <a
            href="tel:+33535759803"
            data-testid="clim-sticky-call"
            className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-full border border-slate-300 text-sm font-bold text-ink"
          >
            <Phone className="h-4 w-4" /> Appeler
          </a>
          <button
            data-testid="clim-sticky-devis"
            onClick={() => scrollToId("#devis")}
            className="flex min-h-[48px] flex-[1.4] items-center justify-center gap-2 rounded-full bg-ice text-sm font-bold text-white"
          >
            Devis gratuit <ArrowRight className="h-4 w-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
